import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Verification = _resolveComponent("Verification")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isVerified)
      ? (_openBlock(), _createBlock(_component_Verification, {
          key: 0,
          onVerified: _ctx.onVerified
        }, null, 8, ["onVerified"]))
      : _createCommentVNode("", true),
    (_ctx.isVerified)
      ? (_openBlock(), _createBlock(_component_NavBar, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.isVerified)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isVerified)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}